import React, { Component } from 'react'


class Notification extends Component {
    state = {
        show: true
    }

    _closeNotification = () => this.setState({ show: false })
    render() {
        const { show } = this.state
        const isInvisible = show ? '' : 'is-invisible'
        const { text, color } = this.props
        return (
            show ?
                <div className={`notification is-${color} ${isInvisible}`}>
                    <button className="delete" onClick={e => this._closeNotification()}></button>
                    {text}
                </div> : ''
        )
    }
}

export default Notification


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Notifications/Notification.js